export class BasicRoomInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(roomId: string, roomName: string | null);
    constructor(roomId?: string, roomName?: string | null) {
        if (roomId !== undefined) {
            this.id = roomId;
            this.name = roomName;
        }
    }
}